import { render, staticRenderFns } from "./EditTaskTypeModal.vue?vue&type=template&id=31e1f316&scoped=true&"
import script from "./EditTaskTypeModal.vue?vue&type=script&lang=js&"
export * from "./EditTaskTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTaskTypeModal.vue?vue&type=style&index=0&id=31e1f316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e1f316",
  null
  
)

export default component.exports